import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CodeOutline } from '@bonusly/design-system';
import { useFeatureFlag } from '@bonusly/who-am-i';

import { ExperimentCard } from '../components/experiment-card';
import { FlagStatus } from '../components/flag-status';

const FLAG = 'labs-sample';

export const SampleExperiment: FC = () => {
	const { t } = useTranslation('labs');
	const isEnabled = useFeatureFlag(FLAG);

	return (
		<ExperimentCard
			icon={<CodeOutline size="md" />}
			title={t('experiments.sample.title')}
			description={t('experiments.sample.description')}
			footer={<FlagStatus flagName={FLAG} isEnabled={isEnabled} />}
		/>
	);
};
